import styled, { css } from 'styled-components';
import BaseArrowLink from 'Elements/Link/Arrow';

import { StyledLink } from 'Components/SupportBlock/Link/Link.styled';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        background: var(--campaign-bg-colour, ${theme.colors.primary.hex});
        color: var(--campaign-txt-colour, ${theme.colors.primaryContrast.hex});
        padding: 2rem 0 2.5rem;

        @media ${theme.breakpoints.medium.media} {
            min-height: 9.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            min-height: 12rem;
        }
    `}
`;

export const Background = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
`;

export const Inner = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        margin-bottom: 1.25rem;

        @media ${theme.breakpoints.medium.media} {
            margin: 0;
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-weight: 300;
        font-size: 2rem;
        margin-top: 0rem;

        @media ${theme.breakpoints.medium.media} {
            margin: 0 0 0.5rem 0;
            font-size: 2rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 3rem;
        }
    `}
`;

export const PostHeading = styled.span`
    ${({ theme }) => css`
        display: block;
        margin: 1rem 0.5rem 0 0;
        font-size: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 2.25rem;
        }
    `}
`;

export const ArrowLink = styled(BaseArrowLink)`
    ${({ theme }) => css`
        svg {
            color: ${theme.colors.primary.hex};
        }
    `}
`;

export const VoucherWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;

        ${StyledLink} {
            margin-top: 1rem;
        }

        @media ${theme.breakpoints.medium.media} {
            height: 0;
        }

        @media ${theme.breakpoints.large.media} {
            height: auto;
        }
    `}
`;
